<template>
    <span class="w-100">
        <input v-if="type !== 'textarea'" :class="'intake-form--input'+(isInvalid ? ' is-invalid' : '')" type="text" :id="name" :name="name" v-model="inputValue" :placeholder="label"/>
        <textarea v-if="type === 'textarea'" :class="'intake-form--textbox'+(isInvalid ? ' is-invalid' : '')" :id="name" :name="name" v-model="inputValue" :placeholder="label"></textarea>
        <span v-if="required && isInvalid" class="text-danger">*Required</span>
    </span>
</template>

<script>
    export default {
        data() {
            return {
                inputValue: this.value
            }
        },
        computed: {
            isInvalid() {
                if (this.required && (this.inputValue === null || this.inputValue === '')) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        props: ['type', 'value', 'label', 'name', 'required'],
        watch: {
            inputValue(val) {
                this.$emit('field-changed', this.name, val, !(this.isInvalid));
            }
        }
    }
</script>